export default (context) => {
    context.popup.text = 'В тексте запрещается использовать нецензурную лексику.'
    context.popup.growButton = true
    context.overlay = true
    context.popup.value = true
}